module.exports = __webpack_public_path__ + "static/media/logo_color.15e582df.png";